import ReactGA from 'react-ga4';

// Google Analytics 초기화
export const initGA = () => {
    ReactGA.initialize('G-D4K59F66JR'); // 여기에 실제 측정 ID를 입력하세요
};

// 페이지뷰 추적
export const logPageView = () => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};

// 이벤트 추적
export const logEvent = (category: string, action: string, label?: string) => {
    ReactGA.event({
        category,
        action,
        label,
    });
}; 